//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebhookEntityNotificationType } from './WebhookEntityNotificationType';

export class WebhookInputItem extends ItemBase {
    Url: string | null = null;
    Description: string | null = null;
    Enabled: boolean = false;
    LimitToEntityNotificationTypes: WebhookEntityNotificationType[] = [];

    constructor(initializer?: Partial<WebhookInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebhookInputItem";
}
